export default __webpack_public_path__ + "static/banner.dark-4b62466fd5dd6daa87868f44fb373838f52c45927d1efa76a9443886d0aa3b87.png";